package top.wcpe.allincore.ui.runtime.theme

/**
 * ProgressBar 控件主题令牌（ADR-0048 内部分组）。
 *
 * 由 [ControlTheme] 内部持有，`ControlTheme` 的 `progressBarXxx` accessor 委托至此——签名不变、消费者零改动。
 * 字段名去 `progressBar` 前缀（holder 已表明归属）。默认值与原 `ControlTheme.Builder` 一致（零回归）。
 */
data class ProgressBarTokens(val notchColor: Int = DEFAULT_NOTCH_COLOR) {
    private companion object {
        private const val DEFAULT_NOTCH_COLOR = 0x80000000.toInt()
    }
}
